<template>
  <div>
    <!-- VERIFICAR SE A LABEL PARA 'IPI - Alíquota Efetiva (Simples Nacional)' ESTÁ VINDO CORRETA E TIRAR O HARD CODE -->
    <!-- <Cabecalho
      v-if="registro.aliquota == '0,00%'"
      tipo="porcentagem2"
      :titulo="registro.label"
      :aliquota="registro.aliquota"
    /> -->
    <div v-if="registro.label">
      <Cabecalho
        :tipo="
          registro.simples_aliquota_reparticao && !this.alteracaoImportacao
            ? 'porcentagem5'
            : 'porcentagem2'
        "
        :titulo="
          `${registro.label} ${
            registro.simples_rba_dentro_limite
              ? ` - Aplicável a receita de ${formataDinheiro(registro.simples_rba_dentro_limite)}`
              : ''
          }`
        "
        :aliquota="
          registro.simples_aliquota_reparticao
            ? registro.simples_aliquota_reparticao
            : registro.aliquota
        "
      />
      <Separador :dado="registro" />
    </div>

    <div v-if="registro.label == 'Tributável com Alíquota Zero'">
      <Ncm :ncm="registro.ncm" />
      <Separador :dado="registro" />
    </div>

    <SubRegistro
      class="reducao-container"
      v-if="!!registro.aliquota_efetiva && registro.tipo_red"
      :classe="imposto.classe"
    >
      <Cabecalho :titulo="'Alíquota'" :aliquota="registro.aliquota" />
      <div class="separador" />

      <Cabecalho
        v-if="registro.red_aliquota"
        :titulo="`Redução de alíquota ${registro.tipo_red.toLowerCase()}:`"
        :aliquota="registro.red_aliquota"
      />
      <Cabecalho
        v-if="registro.red_aliquota_outra"
        :titulo="`Redução de alíquota ${registro.tipo_red.toLowerCase()}:`"
        :aliquota="registro.red_aliquota_outra"
      />
    </SubRegistro>

    <Memoria :titulo="'Memória de cálculo:'" :memoria="registro.simples_memoria_efetiva" />
    <Separador
      :dado="
        registro.simples_memoria_efetiva &&
          (registro.simples_memoria_excedente || registro.simples_base_legal)
      "
    />
    <Cabecalho
      v-if="registro.simples_aliquota_efetiva_excedente"
      tipo="porcentagem5"
      :titulo="
        `IPI - Alíquota efetiva com excedente (Simples Nacional) ${
          registro.simples_valor_excedente
            ? ` - Aplicável a receita de ${formataDinheiro(registro.simples_valor_excedente)}`
            : ''
        }`
      "
      :aliquota="registro.simples_aliquota_efetiva_excedente"
    />
    <Separador
      :dado="registro.simples_aliquota_efetiva_excedente && registro.simples_memoria_excedente"
    />

    <Memoria :titulo="'Memória de cálculo:'" :memoria="registro.simples_memoria_excedente" />
    <Separador :dado="registro.simples_memoria_excedente && registro.simples_base_legal" />

    <Notificacao v-if="registro.simples_alerta" :tipo="'alerta'" :texto="registro.simples_alerta" />

    <GrupoNotificacao v-if="registro" :registro="registro" />

    <Separador
      v-if="!!registro.simples_base_legal && (registro.simples_alerta || registro.obs)"
      :dado="registro"
    />

    <BaseLegal :base_legal="registro.simples_base_legal" :classe="imposto.simples_base_legal" />
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Memoria from "../Memoria/Memoria.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import SubRegistro from "@/components/SubRegistro/SubRegistro.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

export default {
  name: "IpiSimplesNacional",
  props: {
    imposto: Array | Object,
    registro: Array | Object
  },
  inject: ["alteracaoImportacao"],
  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    GrupoNotificacao,
    RadioButton,
    Registro,
    Separador,
    Memoria,
    Ncm,
    Notificacao,
    SubRegistro
  },

  methods: {
    formataDinheiro(numero) {
      const valor = +numero.replace(",", ".");
      const real = valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      return real;
    }
  }
};
</script>

<style lang="scss" scoped></style>
